import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ru from './langs/ru.json';
import en from './langs/en.json';
import de from './langs/de.json';
import es from './langs/es.json';
import fr from './langs/fr.json';
import it from './langs/it.json';
import ja from './langs/ja.json';
import ko from './langs/ko.json';
import pl from './langs/pl.json';
import pt from './langs/pt.json';
import tr from './langs/tr.json';
import uk from './langs/uk.json';
import nl from './langs/nl.json';
import sv from './langs/sv.json';
import id from './langs/id.json';
import cs from './langs/cs.json';
import { getUserLanguage } from '@/utils/langs';

export const langList = [
  { code: 'ru', name: 'Русский' },
  { code: 'en', name: 'English' },
  { code: 'de', name: 'Deutsch' },
  { code: 'nl', name: 'Nederlands' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'it', name: 'Italiano' },
  { code: 'sv', name: 'Svenska' },
  { code: 'id', name: 'Bahasa Indonesia' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
  { code: 'pl', name: 'Polski' },
  { code: 'pt', name: 'Português' },
  { code: 'tr', name: 'Türkçe' },
  { code: 'uk', name: 'Українська' },
  { code: 'cs', name: 'Čeština' },
];

i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en },
    de: { translation: de },
    es: { translation: es },
    fr: { translation: fr },
    it: { translation: it },
    ja: { translation: ja },
    sv: { translation: sv },
    id: { translation: id },
    ko: { translation: ko },
    pl: { translation: pl },
    pt: { translation: pt },
    tr: { translation: tr },
    uk: { translation: uk },
    nl: { translation: nl },
    cs: { translation: cs },
  },
  fallbackLng: 'en',
  lng: getUserLanguage(),
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
